import PropTypes from 'prop-types';
import Helmet from '../../components/Helmet';

import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

import { useNavigate, useSearchParams } from 'react-router-dom';
import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { OrderConfirmation as ClassityOrderConfirmation } from '@classity-edtech/ui-order';
import { CurrencyCode, PaymentStatuses } from '@classity-edtech/platform-utils';
import { useGetPaymentQuery } from '../../services/payments';
import { CircularProgress } from '@mui/material';
import { webPaths } from '../../routes/paths';

export interface HomeProps extends MuiBoxProps {}

export const OrderConfirmation = ({ className }: HomeProps) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get('transactionId');
  const transactionRef = searchParams.get('transactionRef');
  const { data: payment, isLoading } = useGetPaymentQuery(
    {
      id: transactionId,
    },
    { skip: !transactionId },
  );

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: payment?.order?.currencyCode || CurrencyCode.NG,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const handleNextAction = () => {
    navigate(`/${webPaths.dashboard}`);
  };

  return (
    <>
      <Helmet />
      {isLoading ? (
        <Box
          className={className}
          sx={{
            height: '100vh',
            width: '100vw',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <ClassityOrderConfirmation
          paymentStatus={searchParams.get('paymentStatus') as PaymentStatuses}
          transactionId={transactionRef}
          orderId={`${payment?.order?.uid}`}
          time={dayjs(payment?.meta?.created).format('lll')}
          paymentMethod={payment?.paymentServiceProvider?.paymentMethod}
          amount={currencyFormatter.format(payment.order.totalAmount)}
          nextAction={handleNextAction}
        />
      )}
    </>
  );
};

OrderConfirmation.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

OrderConfirmation.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(OrderConfirmation)(
  ({ theme }) => `
  &.MuiBox-root {
    background-color: ${theme.palette.background.paper};
  }
`,
);
